<div class="pos-panel">
    <div class="pos-new-entity-header">
        <span class="material-icons cyan">trolley</span>
        <span class="soc-panel-h">{{(stockTake.statusType == InventoryActionStatus.Pending ? 'STOCK_TAKE.STOCK_TAKE_DETAILS' : 'STOCK_TAKE.COMPLETED_STOCK_TAKE_DETAILS') | translate}}</span>
        <span [ngClass]="stockTake.statusType == InventoryActionStatus.Pending ? 'soc-pill-lbl soc-cyan-pill-outline' : 'soc-pill-lbl soc-neutral-30-pill-outline'">{{stockTake.statusType == InventoryActionStatus.Pending ? 'PENDING' : stockTake.statusType == InventoryActionStatus.Done ? 'DONE' : 'CANCELLED' | translate}}</span>
    </div>
    <hr class="soc-panel-line"/>
    <div class="pos-actions-wrapper">
        <div class="soc-wrapper-gap-24">
            <div class="soc-display-field-wrapper">
                <label class="soc-input-lbl w-100 text-start">{{'STOCK_TAKE.ISSUED_BY' | translate}}</label>
                <div class="soc-display-field"> <span class="soc-display-text">{{stockTake.issuedByUser?.firstName + " " + stockTake.issuedByUser?.lastName}}</span></div>
            </div>
            <div class="soc-display-field-wrapper">
                <label class="soc-input-lbl w-100 text-start">{{'STOCK_TAKE.ASSIGNED_TO' | translate}}</label>
                <div class="soc-display-field"> <span class="soc-display-text">{{stockTake.assignedToUser?.firstName}} {{stockTake.assignedToUser?.lastName}}</span></div>
            </div>
        </div>
        <div class="soc-wrapper-gap-24">
            <div class="soc-display-field-wrapper">
                <label class="soc-input-lbl w-100 text-start">{{'STOCK_TAKE.ISSUE_DATE' | translate}}</label>
                <div class="soc-display-field"> <span class="soc-display-text">{{stockTake.issuedOn  | tzConvert: timezoneOffset:'DD MMM YYYY'}}</span></div>
            </div>
            <div *ngIf="stockTake.statusType == 'done'" class="soc-display-field-wrapper">
                <label class="soc-input-lbl w-100 text-start">{{'STOCK_TAKE.FINISH_DATE' | translate}}</label>
                <div class="soc-display-field"> <span class="soc-display-text">{{stockTake.countedOn}}</span></div>
            </div>
        </div>
    </div>
    <p-table *ngIf="stockTake.lineItems" class="soc-borderless-table" [value]="stockTake.lineItems" [scrollable]="true" [virtualScroll]="true" scrollHeight="calc(100vh - 462px)">
        <ng-template pTemplate="header">
            <tr> 
                <th>{{'INVENTORY_ITEM.CODE' | translate}}</th> 
                <th>{{'INVENTORY_ITEM.ITEM_NAME' | translate}}</th> 
                <th>{{'STOCK_TAKE.COUNTED_QUANTITY' | translate}}</th> 
                <th>{{'STOCK_TAKE.CURRENT_QUANTITY' | translate}}</th> 
                <th>{{'STOCK_TAKE.DISCREPANCY' | translate}}</th> 
            </tr> 
        </ng-template>
        <ng-template pTemplate="body" let-stockTakeItem  let-rowIndex="rowIndex">            
            <tr>
                <td class="secondary-td">{{stockTakeItem.item.code}}</td>
                <td>{{stockTakeItem.item.name}}</td>
                <td>{{stockTakeItem.quantityCounted != null ? stockTakeItem.quantityCounted + " " + (stockTakeItem.item.unitType | unitShortener | lowercase) : '-' }}</td>
                <td>{{stockTakeItem.quantityExpected != null ? stockTakeItem.quantityExpected + " " + (stockTakeItem.item.unitType | unitShortener | lowercase) : '-' }}</td>
                <td>
                    <span [ngClass]="{'soc-danger-color': stockTakeItem.quantityExpected != null && stockTakeItem.quantityCounted != null && (stockTakeItem.quantityCounted - stockTakeItem.quantityExpected) != 0}">{{stockTakeItem.quantityExpected != null && stockTakeItem.quantityCounted != null ? (stockTakeItem.quantityCounted - stockTakeItem.quantityExpected  | number: '1.0-2') + " " + (stockTakeItem.item.unitType | unitShortener | lowercase) : '-' }}
                    </span></td>
            </tr> 
        </ng-template>
    </p-table>
    <hr class="soc-panel-line"/>
    <div class="d-flex align-items-center justify-content-between">
        <button class="soc-secondary-grey-btn" (click)="navigateToMain()"><span class="material-icons-round">arrow_back</span>{{'BACK' | translate}}</button>
        <button *ngIf="stockTake.statusType == InventoryActionStatus.Pending" class="soc-basic-orange-btn" (click)="cancelStockTake()">{{'STOCK_TAKE.CANCEL_STOCK_TAKE' | translate}}</button>
    </div>
</div>
<p-confirmDialog class="soc-confirmation-dialog">
</p-confirmDialog>